import * as styles from './styles';
import FocusableBackButton from '@components/FocusableBackButton';
import { usePatientNameContext } from '@context/PatientName';

const Content = () => {
  const { goPatientSelection } = usePatientNameContext();

  return (
    <div css={styles.content}>
      <div css={styles.textContainer}>
        <FocusableBackButton onEnterPress={goPatientSelection} />
        <p css={styles.title}>
          사용자 이름을 <br />
          입력해주세요.
        </p>
      </div>
    </div>
  );
};

export default Content;
